import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSidebarItem from './HseSidebarItem.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSidebarItem;

/* template */
var __vue_render__ = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({tag:"component",staticClass:"hse-SidebarItem",class:( _obj = {}, _obj[("hse-SidebarItem_size_" + _vm.computedSize)] = _vm.computedSize, _obj['hse-SidebarItem_selected'] =  _vm.selected, _obj['hse-SidebarItem_hasIcon'] =  _vm.hasIcon, _obj['hse-SidebarItem_hasLabel'] =  _vm.hasLabel, _obj ),on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.additionalProps,false),[(_vm.hasIcon)?_c('div',{staticClass:"hse-SidebarItem__icon",class:_vm.classes.icon},[_c('HseIcon',{attrs:{"icon":_vm.icon,"size":"medium"}}),_vm._v(" "),(_vm.showIconBadge)?_c('HseBadgeLabel',{staticClass:"hse-SidebarItem_iconBadge",attrs:{"selected":true,"size":"smallX","variant":"filled"}},[_vm._t("label",[_vm._v("\n        "+_vm._s(_vm.label)+"\n      ")])],2):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hse-SidebarItem__right",class:_vm.classes.right},[(_vm.$slots.default)?_c('div',{staticClass:"hse-SidebarItem__title",class:_vm.classes.title},[_vm._t("default")],2):_vm._e(),_vm._v(" "),(_vm.hasLabel)?_c('div',{staticClass:"hse-SidebarItem__labelContainer"},[(_vm.hasLabel)?_c('HseBadgeLabel',{staticClass:"hse-SidebarItem__label",class:_vm.classes.label,attrs:{"selected":true,"size":"medium","variant":"filled"}},[_vm._t("label",[_vm._v("\n          "+_vm._s(_vm.label)+"\n        ")])],2):_vm._e()],1):_vm._e()])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
